<template>
    <RegisterForm  />
</template>

<script>
// @ is an alias to /src
import RegisterForm from "@/components/RegisterForm.vue";

export default {
  name: "home",
  components: {
    RegisterForm
  }
};
</script>
